export default "__VITE_ASSET__Dq9h_MYy__"